<template>
  <v-container>
    <AddNewGroupDialog ref="addNewGroupDialog" @changeEvent="doneNewGroup" />
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="salespersonSelect"
          :items="salesPersons"
          item-value="id"
          item-text="name"
          :menu-props="{ closeOnClick: true }"
          label="Assign Users"
          multiple
          append-icon=""
          prepend-icon="fal fa-user"
        >
          <template v-slot:prepend-item v-if="salesPersons.length > 0">
            <v-list-item ripple @click="selectAll">
              <v-list-item-action>
                <v-checkbox v-model="selectedAll"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title> Select All </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>

          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 3">
              <span>{{ item.name }}</span>
            </v-chip>

            <span v-if="index === 3" class="grey--text caption">
              (+{{ salespersonSelect.length - 3 }} others)
            </span>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-autocomplete
          v-model="assign.group_ids"
          :items="groups"
          item-text="name"
          item-value="id"
          :menu-props="{ closeOnClick: true }"
          label="Assign groups"
          multiple
          append-icon=""
          prepend-icon="fal fa-user-friends"
        >
          <template v-slot:selection="{ item }">
            <v-chip :small="assign.group_ids.length >= 4">
              <span>{{ item.name }}</span>
            </v-chip>
          </template>

          <template v-if="canUpdateCreateGroup" v-slot:prepend-item>
            <v-list-item ripple @click="createNewGroup()">
              <v-list-item-content>
                <v-list-item-title
                  style="
                    font-size: 17px;
                    display: flex;
                    justify-content: center;
                    gap: 7px;
                    align-items: center;
                  "
                >
                  <i class="fas fa-plus"></i>
                  <span>Create New Group</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>

          <template v-slot:item="{ item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-action>
                <v-checkbox :input-value="active"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-row no-gutters align="center">
                  <span>{{ item.name }}</span>
                  <v-spacer></v-spacer>
                  <v-btn
                    v-if="canUpdateCreateGroup"
                    icon
                    large
                    v-on:click.stop="editGroup(item)"
                  >
                    <v-icon small>fal fa-edit</v-icon>
                  </v-btn>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-menu
          ref="dueDateMenu"
          v-model="dueDateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="assign.due_date"
              label="Due Date"
              persistent-hint
              prepend-icon="fal fa-calendar"
              v-bind="attrs"
              readonly
              @blur="date = parseDate(assign.due_date)"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            no-title
            @input="dueDateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { each as _each } from 'lodash-es';
import AddNewGroupDialog from './../../user-management/user/partial/AddNewGroupDialog.vue';
import { canUpdateCreateGroups } from './../../../helper/user/roleHelper';

export default {
  name: 'AssignContent',
  components: {
    AddNewGroupDialog,
  },

  props: {
    value: Boolean,
  },

  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      salespersonSelect: [],
      isLoading: false,
      assign: {
        group_ids: [],
        user_ids: [],
        due_date: this.formatDate(new Date().toISOString().substr(0, 10)),
      },
      dueDateMenu: false,
      groups: [],
    };
  },
  watch: {
    date(val) {
      this.assign.due_date = this.formatDate(this.date);
    },
  },
  computed: {
    canUpdateCreateGroup() {
      return canUpdateCreateGroups(this.$auth.user().roles);
    },
    salesPersons() {
      let list = this.$store.state.lmsClient.listUsers;
      if (list.length < 1) {
        this.fetchUsers();
      }
      return list;
    },
    selectedSome() {
      return this.salespersonSelect.length > 0 && !this.selectedAll;
    },
    selectedAll() {
      return this.salespersonSelect.length === this.salesPersons.length;
    },
  },
  created() {
    this.getGroups();
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    getGroups() {
      this.$http
        .get('/groups')
        .then((response) => {
          _each(response.data, (group) => {
            this.groups.push(group);
          });
        })
        .catch((err) => {});
    },
    fetchUsers() {
      this.salesPersonsLoading = true;
      this.$store
        .dispatch('lmsClient/fetchUsersByDealer')
        .then(({ data }) => {
          this.$store.dispatch('lmsClient/setUsers', data);
          this.salesPersonsLoading = false;
        })
        .catch(() => {
          console.log('error');
        });
    },
    selectAll() {
      this.$nextTick(() => {
        if (this.selectedAll) {
          this.salespersonSelect = [];
        } else {
          let allIds = this.salesPersons.slice().map((item) => {
            return item.id;
          });
          this.salespersonSelect = allIds;
        }
      });
    },

    hideMenuContentWhenOpeningNewDialog() {
      let el = document.getElementsByClassName('menuable__content__active');
      el[0].classList.add('display-none');
    },
    createNewGroup() {
      this.hideMenuContentWhenOpeningNewDialog();
      this.$refs['addNewGroupDialog'].toggleDialog('Create New Group', false);
    },
    doneNewGroup(item) {
      if (item.isUpdate) {
        let indexToModify = this.groups.findIndex(
          (group) => group.id === item.id
        );
        if (indexToModify > -1) {
          this.groups[indexToModify].name = item.name;
          this.groups[indexToModify].users = item.users;
        }

        if (!this.assign.group_ids.includes(item.id)) {
          this.assign.group_ids.push(item.id);
        }
      } else {
        if (item) this.groups.push(item);
        if (item.id) this.assign.group_ids.push(item.id);
      }
    },
    editGroup(item) {
      this.hideMenuContentWhenOpeningNewDialog();
      this.$refs['addNewGroupDialog'].toggleDialog('Edit Group', item);
    },
  },
};
</script>

<style></style>
